import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcMenu(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.25 5.25a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1 0-1.5zM20.25 11.25a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1 0-1.5zM20.25 17.25a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1 0-1.5z"
  }));
}
var IcMenu = createNolIcon(/*#__PURE__*/forwardRef(SvgIcMenu));

export { IcMenu as I };
